<template>
  <div class="photo--preview">
    <div class="first--col">
      <picture>
        <source :srcset="photoSource" type="image/webp" />
        <source :srcset="getFallbackImage(photoSource)" type="image/jpeg" />
        <img
          :src="getFallbackImage(photoSource)"
          width="100%"
          height="auto"
          class="photo--image input--margin"
        />
      </picture>
    </div>
    <div class="second--col">
      <div>{{ photo.fileName }}</div>
      <div class="text-danger" v-if="photo.uploadStatus === 'failed'">
        Upload gagal. <button type="button" @click="$emit('retry', photo)">Coba lagi</button>
      </div>
      <div v-else-if="photo.uploadStatus && photo.uploadStatus !== 'uploaded'">Mengunggah...</div>
      <div class="use--primary">
        <div class="check" :class="{ checked: photo.isPrimary }" @click="togglePrimary"></div>
        <input
          :id="`set-primary-${photo.uuid || photo.localId}`"
          :checked="photo.isPrimary"
          type="radio"
          class="radio--input"
          @click="togglePrimary"
        />
        <label class="radio--label" :for="`set-primary-${photo.uuid || photo.localId}`">{{
          $t('addListing.primaryPhoto')
        }}</label>
      </div>
    </div>
    <div class="third--col">
      <img src="@/assets/img/icons/trash.svg" @click="removePhoto" class="trash--button" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import HelperMixin from '@/mixins/helpers';
import { deletePhoto } from '@/services/listingDraftRepository';

export default {
  name: 'photo-preview',
  props: ['index', 'photo', 'length'],
  mixins: [HelperMixin],
  computed: {
    ...mapState({
      baseUrl: (state) => state.global.baseUrl,
      draftId: (state) => state.listingForm.localDraftId,
    }),
    photoSource() {
      if (this.photo.src.search('/storage/') !== -1) {
        return this.baseUrl + this.photo.src;
      } else {
        return this.photo.src;
      }
    },
  },
  methods: {
    togglePrimary() {
      this.$store.commit('listingForm/sect2/media/TOGGLE_PRIMARY_PHOTO', this.index);
    },
    async removePhoto() {
      if (this.draftId && this.photo.localId) {
        try {
          await deletePhoto(this.draftId, this.photo.localId);
        } catch (error) {
          console.error('Failed to delete local listing photo:', error);
        }
      }
      this.$store.commit('listingForm/sect2/media/REMOVE_PHOTO', this.index);
    },
  },
};
</script>

<style scoped></style>
